import { ArrowUpRight, Check } from "lucide-react";

const CLIENT_IMG =
    "https://images.pexels.com/photos/11877375/pexels-photo-11877375.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const DRIVER_IMG =
    "https://images.unsplash.com/photo-1516862523118-a3724eb136d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBkcml2ZXJ8ZW58MHx8fHwxNzgwMzA0NjI1fDA&ixlib=rb-4.1.0&q=85";

const Card = ({ tag, title, items, img, cta, testid, dark = false }) => (
    <div
        data-testid={testid}
        className={`relative flex flex-col ${
            dark ? "bg-ink text-white" : "bg-white text-ink"
        } border border-slate-200 overflow-hidden`}
    >
        <div className="relative h-80 overflow-hidden">
            <img
                src={img}
                alt={title}
                className="w-full h-full object-cover scale-105 hover:scale-100 transition-transform duration-700"
            />
            <div
                className={`absolute inset-0 ${
                    dark
                        ? "bg-gradient-to-t from-ink via-ink/40 to-transparent"
                        : "bg-gradient-to-t from-white via-white/30 to-transparent"
                }`}
            />
            <span
                className={`absolute top-6 left-6 inline-flex items-center gap-2 ${
                    dark ? "bg-signal text-white" : "bg-ink text-white"
                } px-3 py-1.5 text-xs font-bold uppercase tracking-wider`}
            >
                {tag}
            </span>
        </div>

        <div className="p-8 lg:p-12 flex-1 flex flex-col">
            <h3 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mb-6">
                {title}
            </h3>
            <ul className="space-y-3 mb-10 flex-1">
                {items.map((it, i) => (
                    <li
                        key={i}
                        className={`flex items-start gap-3 text-base ${
                            dark ? "text-white/80" : "text-slate-600"
                        }`}
                    >
                        <span
                            className={`flex-shrink-0 w-5 h-5 mt-0.5 ${
                                dark ? "bg-signal" : "bg-ink"
                            } flex items-center justify-center`}
                        >
                            <Check
                                className="w-3 h-3 text-white"
                                strokeWidth={3}
                            />
                        </span>
                        {it}
                    </li>
                ))}
            </ul>
            <a
                href="https://carvaelis.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testid}-cta`}
                className={`group/cta inline-flex items-center justify-between border-2 ${
                    dark
                        ? "border-signal hover:bg-signal text-white"
                        : "border-ink hover:bg-ink hover:text-white text-ink"
                } px-6 py-4 font-bold uppercase tracking-wider text-sm transition-colors`}
            >
                {cta}
                <ArrowUpRight className="w-5 h-5 group-hover/cta:translate-x-1 group-hover/cta:-translate-y-1 transition-transform" />
            </a>
        </div>
    </div>
);

export default function DualAudience() {
    return (
        <section
            id="dual-audience"
            data-testid="dual-audience"
            className="section-y bg-white border-y border-slate-200"
        >
            <div className="container-x">
                <div className="max-w-3xl mb-16">
                    <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                        — Deux audiences, une plateforme
                    </p>
                    <h2 className="font-display font-black tracking-tighter text-ink text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                        Conçu pour les{" "}
                        <span className="italic font-medium">clients</span>.
                        Pensé pour les{" "}
                        <span className="italic font-medium">
                            convoyeurs
                        </span>
                        .
                    </h2>
                </div>

                <div className="grid lg:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
                    <Card
                        testid="audience-clients"
                        tag="Clients"
                        title="Faites convoyer votre véhicule sans bouger."
                        img={CLIENT_IMG}
                        cta="Demander un devis"
                        items={[
                            "Devis instantané et tarif fixe garanti",
                            "Convoyeurs vérifiés, notés et assurés",
                            "Suivi GPS en temps réel sur l'application",
                            "Assurance tous risques incluse",
                            "Support 7j/7 par téléphone et chat",
                        ]}
                    />
                    <Card
                        testid="audience-drivers"
                        tag="Convoyeurs"
                        title="Roulez, gagnez. Gérez votre activité."
                        img={DRIVER_IMG}
                        cta="Devenir convoyeur"
                        dark
                        items={[
                            "Missions sélectionnées selon votre zone",
                            "Paiement rapide et sécurisé après livraison",
                            "Outils mobiles pour l'état des lieux digital",
                            "Couverture professionnelle complète",
                            "Communauté de convoyeurs certifiés Carvaelis",
                        ]}
                    />
                </div>
            </div>
        </section>
    );
}
